module.exports = __webpack_public_path__ + "img/doc_2_preview.95dc635a.jpg";